export const graphConstants = {
    GRAPHS_REQUEST: 'GRAPHS_REQUEST',
    GRAPHS_SUCCESS: 'GRAPHS_SUCCESS',
    GRAPHS_FAILURE: 'GRAPHS_FAILURE',
  }
  